import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class QuestionnaireController {
  constructor(
    $http,
    $localStorage,
    $location,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    $httpParamSerializerJQLike,
    SecurityService,
    $rootScope,
    $timeout,
    EnvService,
    $scope
  ) {
    this.name = "questionnaire";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.$security = SecurityService;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.showQuestionsForms = false;
    this.questionForList = "";
    this.deletionArray = [];
    this.$location = $location;
    this.$env = EnvService;
    this.remain_loading_count = 0;
    this.questions = [
      {
        question: "Why are you a good fit?",
        questionType: 1,
        editing: false,
      },
    ];
    this.currentUser = this.$auth.getUserData();
    this.setDeletionUI();

    var _this = this;

    console.log("************QUESTIONNAIRE");
    console.log("************QUESTIONNAIRE");
    console.log("************QUESTIONNAIRE");
    console.dir(_this.$rootScope.$$listenerCount);

    _this.setJobTypeListener = _this.$rootScope.$on("setJobType", function ($event, params) {
      _this.postType = params.postType;
      console.log("what is the post Type?");
      console.dir(_this.postType);
    });

    _this.checkQuestionsListener = _this.$rootScope.$on("checkQuestions", function ($event, params) {
      if (params.clone) {
        try {
          params.questions.sort(function (a, b) {
            return a.id - b.id;
          });
        } finally {
          _this.setQuestionsForCloningProcess(params.questions);
        }
      } else {
        _this.questions = params.questions;
      }
      if (params.postType) {
        _this.postType = params.postType;
      }
    });

    _this.triggerQuestionsGetterListener = _this.$rootScope.$on("triggerQuestionsGetter", function ($event) {
      _this.triggerQuestionsGetter();
    });

    _this.checkQuestionsEditListener = _this.$rootScope.$on("checkQuestionsEdit", function ($event, params) {
      _this.remain_loading_count = 1;
      _this.questions = [];
      _this.event = params.event;

      console.log("_this.event");
      console.dir(_this.event);

      _this.event.surveyQuestions.sort(function (a, b) {
        let order = null;

        console.log("a.displayOrder");
        console.dir(a.displayOrder);

        if (a.displayOrder) {
          order = a.displayOrder - b.displayOrder;
        } else {
          order = a.id - b.id;
        }

        return order;
      });
      _this.questions = _this.event.surveyQuestions;

      _this.$timeout(function () {
        _this.remain_loading_count = 0;
      }, 300);
    });

    _this.$scope.$on("$destroy", _this.setJobTypeListener);
    _this.$scope.$on("$destroy", _this.checkQuestionsListener);
    _this.$scope.$on("$destroy", _this.triggerQuestionsGetterListener);
    _this.$scope.$on("$destroy", _this.checkQuestionsEditListener);

    _this.eventId = this.$stateParams.eventId;
  }

  createQuestion() {
    var _this = this;

    _this.showQuestionsForm = true;
  }

  addQuestionToList() {
    var _this = this;

    console.log("what is the question to be saved");
    console.dir(_this.questionForList);

    if (_this.questionForList) {
      var validation = _this.validateQuestion();

      console.log("whats the valid say");
      console.dir(validation);

      if (_this.errorMax) {
        console.log("too long...");
      } else {
        var qo = {
          question: _this.questionForList,
          questionType: {id: 1, name: "Text", description: null},
          editing: false,
        };

        _this.questions.push(qo);

        if (this.$stateParams.eventId) {
          _this.remain_loading_count = 1;
          _this.saveNewQuestionToDB();
        } else {
          _this.questionForList = "";
        }

        if (validation.status) {
          console.log("in error");
        } else {
        }
      }
    }
  }

  questionChecking() {
    var _this = this;

    if (_this.questionForList.length >= 241) {
      _this.errorMax = true;
      _this.errorMaxMsg = "Your question cannot be longer than 240 characters.";
      _this.errorMaxMsgDisabled = true;
      _this.questionForList = _this.questionForList.substring(0, 240);
    } else {
      _this.errorMax = false;
      _this.errorMaxMsg = null;
      _this.errorMaxMsgDisabled = false;
    }
  }

  validateQuestion() {
    var _this = this;

    var returnobj = {};

    try {
      if (_this.questions.length > 10) {
        _this.error = true;
        _this.errormsg = "You have already asked your max amount of questions (three).";
        returnobj.status = true;
        returnobj.error = "You have already asked your max amount of questions (three).";
      } else {
        returnobj.status = false;
        _this.error = false;
        _this.errormsg = null;
      }
    } finally {
      return returnobj;
    }
  }

  saveNewQuestionToDB() {
    console.log("saveNewQuestionToDB");

    var _this = this;

    console.log("lets replace the questions");
    console.dir(_this.questions);
    console.dir(_this.event);
    console.dir(_this.questionForList);
    console.dir(_this.questionForEdit);

    var ques = _this.questionForList;

    _this.$timeout(function () {
      _this.questionForList = "";
    });

    try {
      var quesObjSave = {};
      for (var i = 0; i < _this.questions.length; i++) {
        //delete _this.questions[i].id;
        if (!_this.questions[i].questionType) {
          console.log("no quesiton type");
          quesObjSave.questionType = 1;
          quesObjSave.name = "Question " + (i + 1);
          quesObjSave.question = _this.questions[i].question;
          _this.questions.splice(i, 1);
          _this.questions.push(quesObjSave);
          break;
        }
      }
    } finally {
      var eventData = {
        method: "PUT",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.$stateParams.eventId + "?format=json&conf=web",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {
          surveyQuestions: _this.questions,
        },
      };

      _this.$http(eventData).then(
        function (response) {
          console.log("?");
          console.dir(response);
          if (response.data.status !== "error") {
            console.log("success");
            _this.remain_loading_count = 0;
          } else {
            console.log("error saving questions");
            _this.remain_loading_count = 0;
            alert("Error saving your new question. Please contact support");
          }
        },
        function (response) {
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }

    /*
	  if (_this.isEditExistingQuestion) {
		  var questionData = {
				  method: 'PUT',
				  url: _this.$env.getAPIEndPoint() + "jbl/v1/survey-questions/" + _this.quesObjForSave.id + "?format=json&conf=web",
				  headers: {
					  'Content-Type': 'application/json;charset=UTF-8',
					  'Authorization': 'Bearer ' + _this.currentUser.access_token
				  },
				  data : {
					  question : ques
				  }
		  };

		  _this.$http(questionData).then(function(response) {

			  console.log('response from back end');
			  console.dir(response);

			  if (response.data.status !== 'error') {

			  } else {

			  }

		  }, function(response) {
			  _this.$timeout(function() {
				  jQuery('#show-application-alert').trigger('click');
			  }, 100);

		  })

	  } else {

		  console.log('pretty sure we come down to this else');
		  try {
			  var quesObjSave = {};
			  for (var i = 0; i < _this.questions.length; i++) {
				  if (!_this.questions[i].questionType) {
					  console.log('no quesiton type');
					  quesObjSave.questionType = 1;
					  quesObjSave.name = "Question " + (i + 1);
					  quesObjSave.question = _this.questions[i];
					  _this.questions.splice(i, 1);
					  _this.questions.push(quesObjSave);
					  break;
				  }
			  }

		  } finally{
			  var eventData = {
					  method: 'PUT',
					  url: _this.$env.getAPIEndPoint() + "jbl/v1/events/" + _this.$stateParams.eventId + "?format=json&conf=web",
					  headers: {
						  'Content-Type': 'application/json;charset=UTF-8',
						  'Authorization': 'Bearer ' + _this.currentUser.access_token
					  },
					  data : {
						  surveyQuestions : _this.questions
					  }
			  };

			  _this.$http(eventData).then(function(response) {

				  if (response.data.status !== 'error') {

				  } else {

				  }

			  }, function(response) {
				  _this.$timeout(function() {
					  jQuery('#show-application-alert').trigger('click');
				  }, 100);

			  })
		  }

	  }*/
  }

  deleteQuestion(question, index) {
    console.log("editQuestion");
    console.dir(question);
    console.dir(index);
    var _this = this;

    question.deleting = true;
  }

  editQuestion(question, index) {
    var _this = this;

    console.log("_this.isEditExistingQuestion");
    console.dir(_this.isEditExistingQuestion);
    if (_this.isEditExistingQuestion === true) {
      console.log("its true...");
      return;
    }

    question.editing = true;
    _this.isEditExistingQuestion = true;

    console.log("editQuestion");
    console.dir(_this.$stateParams.eventId);

    if (_this.$stateParams.eventId) {
      _this.questionForEdit = question.question;
      _this.quesObjForSave = question;
    } else {
      _this.questionForEdit = question.question;
      console.log("what is the question?");
      console.dir(_this.questionForEdit);
    }
  }

  cancelEditQuestion(question, index) {
    var _this = this;
    question.editing = false;
    /*
	  _this.isEditExistingQuestion=true;
	  if (_this.$stateParams.eventId){
		  //_this.questionForEdit=question.question;
		  //_this.quesObjForSave=question;
	  }else{
		  //_this.questionForEdit=question.question;
		  console.log('what is the question?');
		  console.dir(_this.questionForEdit);
	  }
	  */
  }

  removeQuestion(question, index) {
    console.log("removeQuestion");

    var _this = this;

    var lenQues = this.questions.length;

    if (lenQues > 1) {
      this.questions.splice(index, 1);
    }

    if (this.$stateParams.eventId) {
      _this.remain_loading_count = 1;
      _this.saveNewQuestionToDB();
    }
  }

  goBackAndSetQuestions() {
    var _this = this;
    try {
      _this.questions.forEach(function (q) {
        q.editing = false;
      });
    } finally {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetQuestionsToEvent", {
          questions: _this.questions,
          type: "back",
        });
      });
    }
  }

  triggerQuestionsGetter() {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("QuestionsTrigger", {
        questions: _this.questions,
      });
    });
  }

  sendToStepSeven() {
    var _this = this;
    try {
      _this.questions.forEach(function (q, i) {
        q.name = "Question " + (i + 1);
        q.editing = false;
      });
    } finally {
      _this.$timeout(function () {
        _this.$rootScope.$emit("SetQuestionsToEvent", {
          questions: _this.questions,
          type: "forward",
          currentUser: _this.currentUser,
        });
      });
    }
  }

  checkQuestions(params) {
    var _this = this;

    console.log("checkQuestions");
    console.dir(params);
    console.dir(_this.questions);
    console.dir(params.questions);

    _this.$timeout(function () {
      console.log("scope apply");
      console.dir(_this.$scope);
      _this.$scope.$apply(function () {
        _this.questionsNew = params.questions;
      });
    });
  }

  saveQuestionAfterEdit(questionObj, is_edit, is_delete) {
    var _this = this;
    console.log("what is the question rn?");
    console.dir(questionObj);
    console.dir(_this.questionForEdit);
    console.dir(_this.$location.$$url);
    if (_this.$location.$$url.indexOf("/post-event") > -1) {
      console.log("were on the creation flow");
      _this.isEditExistingQuestion = false;
    } else {
      console.log("questionObj.id");
      console.dir(questionObj.id);
      console.dir(is_edit);

      if (questionObj.id && is_edit) {
        _this.updateQuestion(questionObj);
      } else if (is_delete) {
        _this.deleteQuestionConfirm(questionObj);
      }
    }
    questionObj.question = _this.questionForEdit;
    questionObj.editing = false;
    _this.questionForEdit = "";
  }

  setQuestionsForCloningProcess(questions) {
    var _this = this;

    console.log("setQuestionsForCloningProcess");
    console.dir(questions);
    var q = [];
    try {
      questions.forEach(function (ques) {
        var qo = {};
        qo.name = ques.name;
        qo.question = ques.question;
        qo.questionType = 1;
        q.push(qo);
      });
    } finally {
      _this.questions = q;
      console.log("new final questions");
      console.dir(q);
    }
  }

  showQuestionInput() {
    var _this = this;
    if (_this.inputQuestion) {
      _this.inputQuestion = false;
    } else {
      _this.inputQuestion = true;
    }
  }

  updateQuestion(q) {
    var _this = this;
    console.log("update question");
    console.dir(q);
    let data = {};
    data.event_id = _this.$stateParams.eventId;
    data.questions = _this.questions;
    _this.setLoader();
    _this.$events.updateQuestion(data).then(
      function (response) {
        console.log("in response");
        console.dir(response);
        _this.isEditExistingQuestion = false;
        _this.unSetLoader();
      },
      function (error) {
        console.log("in error");
        console.dir(error);
        _this.isEditExistingQuestion = false;
        _this.unSetLoader();
      }
    );
  }

  deleteQuestionConfirm(q) {
    var _this = this;
    console.log("find this question");
    console.dir(q);
    console.dir(_this.questions);
    let questions = _this.questions;
    /*
	  _this.questions.filter(function(p) {

		  return !p.channelArrayHolder.some(function(v) {

			  if (v.selected && !v.dontShow) {
				  v.dontShow = true;
				  channelsForDeletion.push(v.id);
			  }

		  });

	  });
	  */

    let pos = questions
      .map(function (e) {
        return e.deleting;
      })
      .indexOf(true);
    console.log("what is the index");
    console.dir(pos);
    questions.splice(pos, 1);
    let data = {};
    data.event_id = _this.$stateParams.eventId;
    data.questions = questions;
    _this.$events.updateQuestion(data).then(
      function (response) {
        console.log("in delete response");
        console.dir(response);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }

  addOrRemoveFromDeletionArray(question, index) {
    var _this = this;
    let idx = _this.deletionArray.indexOf(question.id);
    if (idx < 0) {
      _this.deletionArray.push(question.id);
    } else {
      _this.deletionArray.splice(idx, 1);
    }
    console.log("length of delition array");
    console.dir(_this.deletionArray);
    console.dir(_this.deletionArray.length);
    let compared = _this.questions.length - _this.deletionArray.length;
    if (_this.deletionArray.length > 0 && compared >= 1) {
      console.log("first bracket");
      _this.deletion_model.is_disabled = false;
    } else {
      console.log("second bracket");
      _this.deletion_model.is_disabled = true;
    }
  }

  deleteSelectedQuestions() {
    var _this = this;
    let payload = {};
    payload.event_id = parseInt(_this.$stateParams.eventId, 10);
    payload.question_ids = _this.deletionArray;
    _this.setLoader();
    _this.$events.deleteSurveyQuestions(payload).then(
      function (response) {
        _this.stripQuestionsFromUI(payload);
      },
      function (error) {
        alert("Error deleting questions. Please try again");
        _this.unSetLoader();
      }
    );
  }

  stripQuestionsFromUI(payload) {
    var _this = this;
    console.log("----------------------start process----------------------");
    try {
      payload.question_ids.forEach(function (id, index) {
        let finder = _this.questions.findIndex((o) => o.id === id);
        console.log("questions");
        console.dir(finder);
        console.dir(_this.questions);
        _this.questions.splice(finder, 1);
      });
    } catch (err) {
      console.log("error splicing");
    }
    console.log("what are the questions");
    console.dir(_this.questions);
    _this.unSetLoader();
    _this.uncheckAllQuestions();
  }

  uncheckAllQuestions() {
    var _this = this;

    _this.$timeout(function () {
      _this.questions.forEach(function (q) {
        q.selected = false;
      });
      _this.deletionArray = [];
      _this.deletion_model.is_disabled = false;
      _this.$scope.$apply();
    });

    _this.$timeout(function () {
      _this.questions.forEach(function (q) {
        console.log("each question");
        console.dir(q.selected);
      });
    }, 500);
  }

  setDeletionUI() {
    var _this = this;
    let deletion_model = {is_disabled: true};
    _this.deletion_model = deletion_model;
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }
}

QuestionnaireController.$inject = [
  "$http",
  "$localStorage",
  "$location",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "$httpParamSerializerJQLike",
  "security",
  "$rootScope",
  "$timeout",
  "env",
  "$scope",
];

export default QuestionnaireController;



// WEBPACK FOOTER //
// ./client/app/common/questionnaire/questionnaire.controller.js